
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteTask, fetchTasks } from "../redux/Slices/TasksSlice";
import Search from "../components/Search";
import toast, { Toaster } from "react-hot-toast";
import dayjs from "dayjs";
import { Link, useNavigate } from "react-router-dom";
import styles from "../Style/TaskStyles.module.css";

function Home() {
  const dispatch = useDispatch();
  const { tasks, status, error } = useSelector((state) => state.tasksReducer);

  const [categoryInput, setCategoryInput] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [filterData, setFilterData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchTasks());
  }, [dispatch]);



  const handleCategorySearch=useCallback((category) => {
    if (!category) {
      setFilterData(tasks);
      return;
    }
    const filteredTasks = tasks.filter((task) => task.categories === category);
    setFilterData(filteredTasks);
  },[tasks])










const handleDateSearch=useCallback((date) => {
  if (!date) {
    setFilterData(tasks);
    return;
  }
  const formattedDate = date.format("DD/MM/YYYY");
  const filteredTasks = tasks.filter(
    (task) =>
      dayjs(task.Date, "DD/MM/YYYY").format("DD/MM/YYYY") === formattedDate
  );
  setFilterData(filteredTasks);
},[tasks])




const displayFilterData=useMemo(()=>{
return  filterData.length > 0 ? filterData : tasks
},[filterData,tasks])



  const DeleteTask = (id) => {
    dispatch(deleteTask(id));
    toast.success("Task deleted successfully!");
  };
  function handleUpdate(id) {
    navigate("/EditTaskPage", { state: { id } });
  }
  if (status === "failed") {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      {status === "loading" && <i className="fas fs-5fa-spinner fa-spin"> </i>}

      {status === "failed" && (
        <p className={styles.errorMessage}>Failed to load tasks: {error}</p>
      )}
      <Toaster />
      <Search
        categoryInput={categoryInput}
        setCategoryInput={setCategoryInput}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        handleDateSearch={handleDateSearch}
        handleCategorySearch={handleCategorySearch}
        tasks={tasks}
      />

      <div className={`${styles.Styledcontainer} container mt-3`}>
        <div className="row gap-3 pl-5 justify-center">


          {displayFilterData.map((task) => (
            <div className="col-12 col-lg-3 " key={task.id}>
              <div className={`${styles.Styledcard} card pl-3x `}>
                <div className="card-body">
                


                   <Link to={`/taskDetails/${task.id}`} className="text-decoration-none text-dark">


                <div
                    className={`${styles.taskContainer} ${styles.taskStatus}  ${
                      task.Status === "Pending"
                        ? styles.pending
                        : task.Status === "Completed"
                        ? styles.completed
                        : ""
                    }`}
                  >
                    <h6 className={styles.taskId}>{task.id}</h6>
                    <p className={styles.taskName}>
                      <strong>{task.taskName}</strong>
                    </p>
                  </div>
                  {/* Date */}
                  <div className="d-flex justify-between">
                    <p className="">
                      <strong>Due Date</strong> {task.Date}
                    </p>
                    <p className=" ">
                      <strong>CreatedDate</strong> {task.createddate}
                    </p>
                  </div>
                  {/* Pending && Status */}
                  <div className="d-flex justify-between">
                    <p className="card-title">
                      <strong>{task.categories}</strong>
                    </p>

                    <p
                      className={`${styles.taskStatus} ${
                        task.Status === "Pending"
                          ? styles.pending
                          : task.Status === "Completed"
                          ? styles.completed
                          : ""
                      }`}
                    >
                      <strong> {task.Status}</strong>
                    </p>
                  </div>
                </Link>
                  {/* edit && Delete */}
                  <div className="d-flex justify-between">
                    <button
                      className="btn btn-outline-danger"
                      onClick={() => DeleteTask(task.id)}
                    >
                      {/* <button className="btn btn-outline-dark"> */}

                      <i className="bi bi-trash3-fill "></i>
                    </button>{" "}
                    <button
                      className="btn btn-outline-success"
                      onClick={() => handleUpdate(task.id)}
                    >
                      {/* <button className="btn btn-outline-dark"> */}

                      <i className="bi bi-pencil-fill"></i>
                    </button>
                  </div>
                  <div></div>{" "}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Home;
